import * as t from "io-ts";
import nullable from "./nullable";
export const customerContactT = t.strict({
    id: t.string,
    clientId: t.string,
    name: t.string,
    phone: nullable(t.string),
    email: nullable(t.string),
});
//# sourceMappingURL=customer-contact.js.map